import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

/**
 * @see {@link https://github.com/inflearn/ant-man/blob/a5a8c0adbc1180d5add21e1e94e28ff78a235ef8/inflearn/pages/_signup/auth/lib/setRecentlyUsedSocialProvider.js}
 * @see {@link https://github.com/inflearn/fe-shared/blob/897b42b618d9d913556d2484919d7128a93c5784/packages/app-shell/src/components/Modal/LoginModal/LoginModal.tsx#L20}
 */
const LAST_AUTH_PROVIDER_KEY = '_inflearn_spd';

export function useLastAuthProvider() {
  const [lastAuthProvider, setLastAuthProvider] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window !== undefined) {
      setLastAuthProvider(Cookies.get(LAST_AUTH_PROVIDER_KEY) ?? null);
    }
  }, []);

  return { lastAuthProvider };
}
